import Component from '../Component';
/**
 * The `AlertManager` component provides an area in which `Alert` components can
 * be shown and dismissed.
 */
export default class AlertManager extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = this.attrs.state;
  }
  view() {
    const activeAlerts = this.state.getActiveAlerts();
    return m("div", {
      className: "AlertManager"
    }, Object.keys(activeAlerts).map(Number).map(key => {
      const alert = activeAlerts[key];
      const urgent = alert.attrs.type === 'error';
      return m("div", {
        className: "AlertManager-alert",
        role: "alert",
        "aria-live": urgent ? 'assertive' : 'polite'
      }, m(alert.componentClass, Object.assign({}, alert.attrs, {
        ondismiss: this.state.dismiss.bind(this.state, key)
      }), alert.children));
    }));
  }
}
flarum.reg.add('core', 'common/components/AlertManager', AlertManager);